// Modules
import type {GetStaticProps} from 'next';
import {useTranslation} from '@app/hooks/use-translation';
import {serverSideTranslations} from '@app/modules/locale-management/server';
import {LandingSections} from '@tempo/landing';
import {TempoLandingPage} from '@app/components/layout/LandingPage';
import type {LandingProps} from '@app/types/next';
import {
	Stepper,
	ShakerImg,
	ShakerWorks,
	ShakerMusic,
	ShakerPlaylist,
	ShakerTry,
} from '@app/views/features/shaker';
import {getFooterLinksPerLang} from '@app/modules/ssg-data/unlogged-data';

const ShakerPage: React.FC<LandingProps> = () => {
	const {t} = useTranslation();
	const pageTitle = t('shakerearlyaccesslanding_text_seotitle_standalone-web', {
		ns: 'shaker',
	});
	const pageDescription = t(
		'shakerearlyaccesslanding_text_seodescription_standalone-web',
		{ns: 'shaker'},
	);
	return (
		<TempoLandingPage title={pageTitle} description={pageDescription}>
			<LandingSections topGutter>
				<Stepper />
				<ShakerImg />
				<ShakerWorks />
				<ShakerMusic />
				<ShakerPlaylist />
				<ShakerTry />
			</LandingSections>
		</TempoLandingPage>
	);
};

export const getStaticProps: GetStaticProps<LandingProps> = async ({
	locale = '',
	locales = [],
}) => {
	const translations = await serverSideTranslations(locale, [
		'common',
		'shaker',
	]);
	return {
		props: {
			...translations,
			dehydratedState: {
				...(await getFooterLinksPerLang({locale, locales})),
			},
			tracking: {
				pagecategory: 'features',
				pagename: 'shaker',
				cdpViewId: 'features_shaker',
			},
		},
		revalidate: 15 * 60,
	};
};

export default ShakerPage;
